import i18n from "@/langsconfig/i18n"


export const translate = (key: string, options?: any): string => {
  return String(i18n.t(key, options))
}

export const appLang = () => {
  return i18n.language
}

export const isArabic = () => {
  return appLang() === 'ar'
}

export const isEnglish = () => {
  return appLang() === 'en'
}

export const Localizer = (List) => List?.map(item => ({ ...item, label: i18n.t(item?.label) }))